import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetInvoiceSpecificationArgs } from "../schemas";

const getInvoiceSpecificationQueryKey = (args: GetInvoiceSpecificationArgs) =>
  ["getInvoiceSpecification", args.health_care_organization_id, args.invoice_id] as const;

export const useGetInvoiceSpecification = (args: GetInvoiceSpecificationArgs, options?: { enabled?: boolean }) => {
  const client = useApiClient();
  return useQuery(getInvoiceSpecificationQueryKey(args), () => client.getInvoiceSpecification(args), options);
};
